import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { DeviceInfoService } from '@core/services/device-info.service';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  isMobileOverlayBackButtonExcluded,
  MobileOverlayBackButtonHandler,
} from './mobile-overlay-back-button-handler';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'mat-select',
  standalone: false,
})
export class MatSelectMobileBackButtonDirective implements OnInit, OnDestroy {
  private readonly matSelect = inject(MatSelect);
  private readonly elementRef = inject<ElementRef<Element>>(ElementRef);
  private readonly deviceInfoService = inject(DeviceInfoService);
  private readonly destroy$: ReplaySubject<boolean> = new ReplaySubject(1);
  private readonly mobileBackHandler = new MobileOverlayBackButtonHandler({
    isOverlayOpen: () => this.matSelect.panelOpen,
    closeOverlay: () => this.matSelect.close(),
    shouldHandleBackButton: () =>
      this.deviceInfoService.getInfo().deviceTypeDetected === 'PHONE' &&
      !isMobileOverlayBackButtonExcluded(this.elementRef.nativeElement),
  });

  public ngOnInit(): void {
    this.matSelect.openedChange.pipe(takeUntil(this.destroy$)).subscribe(opened => {
      if (opened) {
        this.mobileBackHandler.handleOpened();
        return;
      }

      this.mobileBackHandler.handleClosed();
    });
  }

  public ngOnDestroy(): void {
    this.mobileBackHandler.destroy();
    this.destroy$.next(true);
    this.destroy$.complete();
  }
}
